/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `CommandCenterSection.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { CommandCenterSection } from "./CommandCenterSection";

import { CommandCenterView } from "./CommandCenterView";

export type sectionType = "left_column" | "center_column";

export const sectionTypeValues = { left_column: 0, center_column: 1 };

export abstract class CommandCenterSectionModel {
    id: number;
    commandCenterViewId: number;
    createdAt: Dayjs;
    enabled: boolean;
    sectionConfig: any;
    sectionType: sectionType;
    updatedAt: Dayjs;
    commandCenterView: CommandCenterView | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        commandCenterViewId: number,
        createdAt: Dayjs,
        enabled: boolean,
        sectionConfig: any,
        sectionType: sectionType,
        updatedAt: Dayjs,
        commandCenterView: CommandCenterView | null | undefined
    ) {
        this.id = id;
        this.commandCenterViewId = commandCenterViewId;
        this.createdAt = createdAt;
        this.enabled = enabled;
        this.sectionConfig = sectionConfig;
        this.sectionType = sectionType;
        this.updatedAt = updatedAt;
        this.commandCenterView = commandCenterView;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): CommandCenterSection {
        const newObject = new CommandCenterSection(
            json["id"],
            json["command_center_view_id"],
            dayjs(json["created_at"]).tz(timezone),
            json["enabled"],
            json["section_config"],
            json["section_type"],
            dayjs(json["updated_at"]).tz(timezone),
            json["command_center_view"] == null
                ? json["command_center_view"]
                : CommandCenterView.fromApiObject(json["command_center_view"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            command_center_view_id: this.commandCenterViewId,
            created_at: this.createdAt,
            enabled: this.enabled,
            section_config: this.sectionConfig,
            section_type: this.sectionType,
            updated_at: this.updatedAt,
            command_center_view_attributes: this.commandCenterView?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): CommandCenterSection {
        const clone = Object.create(this) as CommandCenterSection;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
